import React from 'react';

const Footer = () => {
  const footerLinks = {
    productos: [
      { name: 'Reservas', href: '#' },
      { name: 'CRM', href: '#' },
      { name: 'Facturación', href: '#' },
      { name: 'App Móvil', href: '#' },
      { name: 'Automatización', href: '#' }
    ],
    soluciones: [
      { name: 'Coworks', href: '#' },
      { name: 'Empresas', href: '#' },
      { name: 'Inmobiliarias', href: '#' },
      { name: 'Multifamilias', href: '#' },
      { name: 'Gimnasios', href: '#' }
    ],
    recursos: [
      { name: 'Documentación', href: '#' },
      { name: 'Blog', href: '#' },
      { name: 'Casos de Éxito', href: '#' },
      { name: 'Soporte', href: '/soporte' }
    ],
    empresa: [
      { name: 'Nosotros', href: '#' },
      { name: 'Carreras', href: '#' },
      { name: 'Contacto', href: '#' },
      { name: 'Partners', href: '#' }
    ]
  };

  return (
    <footer className="bg-black text-gray-400">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_smart-workspaces/artifacts/joupqq6v_logo_blue_horizontal.png" 
              alt="Cloudbase" 
              className="mb-6 brightness-0 invert"
              style={{ height: '5rem' }}
            />
            <p className="text-sm mb-6 leading-relaxed">
              Plataforma integrada de gestión empresarial para la era moderna.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Productos</h3>
            <ul className="space-y-3">
              {footerLinks.productos.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Soluciones</h3>
            <ul className="space-y-3">
              {footerLinks.soluciones.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Recursos</h3>
            <ul className="space-y-3">
              {footerLinks.recursos.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Empresa</h3>
            <ul className="space-y-3">
              {footerLinks.empresa.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm">
            © 2025 Cloudbase. Todos los derechos reservados.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="/privacidad" className="hover:text-white transition-colors">Privacidad</a>
            <a href="#" className="hover:text-white transition-colors">Términos</a>
            <a href="#" className="hover:text-white transition-colors">Seguridad</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;